import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  empAllowanceCreationValidation,
  empAllowanceDeductionValidation,
} from "core/Operations/ValidationSchema/payrollValidation";
import { useInsertEmpAdditionMutation } from "AppQuries/payroll/addition/emp-addition";
import EmpAllowanceForm from "Components/Form/EmpAllowanceForm";
import { toast } from "core/Operations/toast";
import EmpAllowanceDeductionForm from "Components/Form/EmpAllowanceDeductionForm";
import { useAddEmpAllowanceDeductionMutation } from "AppQuries/payroll/emp-allowance-deduction";
import AllocatedAllowanceDeductionList from "./AllocattedAllowanceDeductionList";
import { BackIcon } from "Components/UI/Icon/Icons";

const AddEmpAllowanceDeduction = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addEmpAllowance,
    isPending,

    isError,
    error,
  } = useAddEmpAllowanceDeductionMutation();

  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      locationCode: userData.locationCode,
      allowanceCode: 0,
      type: "",
      code: "",
      employeeCode: [],
      departmentCode: "",
      description: "",
      haveCPF: false,
      isTaxPayable: false,
      amount: "",
      isActive: true,
      isTemporary: true,
      projectCode: "",
      createUser: userData.userName,
      effectiveDateFrom: "",
      effectiveDateTo: "",
    },
    resolver: yupResolver(empAllowanceDeductionValidation),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitted },
    watch,
  } = methods;

  const employeeCodes = Array.isArray(watch("employeeCode"))
    ? watch("employeeCode")
    : [];
  const allocatedList =
    watch("companyCode") &&
    watch("locationCode") &&
    employeeCodes.length > 0 &&
    watch("type") &&
    watch("code") &&
    watch("effectiveDateFrom") &&
    watch("effectiveDateTo")
      ? employeeCodes.map((empCode) => (
          <AllocatedAllowanceDeductionList
            key={`${empCode}-${watch("effectiveDateFrom")}-${watch(
              "effectiveDateTo"
            )}`}
            companyCode={watch("companyCode")}
            locationCode={watch("locationCode")}
            employeeCode={empCode}
            departmentCode={watch("departmentCode") || 0}
            type={watch("type") === 1 ? "Addition" : "Deduction"}
            typeCode={watch("code")}
            fromDate={watch("effectiveDateFrom")}
            toDate={watch("effectiveDateTo")}
          />
        ))
      : null;

  console.log("allocatedList", allocatedList);

  const onSubmit = (payload) => {
    addEmpAllowance([payload], {
      onSuccess: (data) => {
        if (Array.isArray(data) && data[0]?.response === true) {
          toast.success("Employee Allowance Added Successfully.");
          // setTimeout(() => {
          navigate(`${all_routes.emp_allowance_deduction}`);
          // }, 1000);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add Employee Allowance Deduction</h4>
                    <h6>Add Employee Allowance Deduction details </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">
                        Save Employee Allowance Deduction
                      </Tooltip>
                    }
                  >
                    <button
                      type="submit"
                      className="btn btn-added"
                      disabled={isPending || isSubmitting}
                    >
                      &nbsp;
                      {isPending || isSubmitting ? (
                        <>
                          <i className="fas fa-spinner fa-spin me-2"></i>
                          Loading...
                        </>
                      ) : (
                        <>
                          
                          <Save className="me-2" />
                          Save
                        </>
                      )}
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="back-tooltip">Back</Tooltip>}
                  >
                    <Link
                      className="btn btn-secondary"
                      to={`${all_routes.emp_allowance_deduction}`}
                    >
                      <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    {/* <div className="card-header">
                      <h4 className="card-title">Add Employee Allowance Deduction</h4>
                    </div> */}
                    <div className="card-body">
                      <EmpAllowanceDeductionForm mode="A" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">{allocatedList}</div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddEmpAllowanceDeduction;
